/* eslint-disable class-methods-use-this */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../../../common/page-title/index';
import SettingsForm from './settings-form';

import './styles.css';
import t from '../../../../data/translations';

class Settings extends Component {
  render() {
    return (
      <Container fluid className="staff-reward-settings">
        <Row>
          <Col lg={12}>
            <PageTitle>
              { t('settings') }
            </PageTitle>
            <SettingsForm />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  fetched: state.brands.fetched,
  fetching: state.brands.fetching,
});

export default connect(mapStateToProps)(Settings);
